import type { SvgType } from './types'

export default function TickInCircle({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke={fill}
        strokeWidth={2}
      />
      <path
        d="M7.5 12L10.5 15L16.5 9"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
